import { FC, FormEvent, useRef, useState } from "react";
import { sendBargeIn, sendBargeOut } from "../../store/actions";
import { useChatServerDispatch } from "../../utils/useChatServerDispatch";
import { ActionButton } from "../ActionButton";
import "./AdminBar.scss";

export interface AdminBarProps {
    defaultAgentName?: string;
    onAdminJoin?: (status: boolean) => void;
}

const AdminBar: FC<React.PropsWithChildren<AdminBarProps>> = ({ onAdminJoin }: AdminBarProps) => {
    const name = useRef<HTMLInputElement>(null);

    // We can manage this locally
    // const hasAdminJoined = useSelector<ChatState, boolean | undefined>(state => state.hasAdminJoined);
    const [joined, setJoined] = useState(false);
    const [inputName, setInputName] = useState<string>("");

    function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        setInputName(event.target.value);
    }

    const disable: boolean = inputName === "" || inputName === undefined;

    const dispatch = useChatServerDispatch();

    function onSubmit(event: FormEvent) {
        event.preventDefault();

        if (!joined) {
            dispatch(sendBargeIn(name.current?.value));
            setJoined(true);
            onAdminJoin(true);
        } else {
            dispatch(sendBargeOut());
            setJoined(false);
            onAdminJoin(false);
            setInputName("");
        }
    }

    function renderJoin() {
        return (
            <form className="xappw-admin-input-form" onSubmit={onSubmit}>
                <div className="xappw-admin-input-form__buttons">
                    <ActionButton
                        addClass="xappw-admin-input-form__btn"
                        type="submit"
                        label="Join"
                        disable={disable}
                    />
                </div>

                <div className="xappw-admin-input">
                    <input
                        ref={name}
                        id="adminBarInput"
                        placeholder="Type your name here..."
                        className="xappw-admin-input__input"
                        onChange={handleInputChange}
                    />
                </div>
            </form>
        );
    }

    function renderLeave() {
        return (
            <form className="xappw-admin-input-form" onSubmit={onSubmit}>
                <div className="xappw-admin-input-form__buttons">
                    <ActionButton
                        addClass="xappw-admin-input-form__btn"
                        type="submit"
                        label="Leave"
                    />
                </div>
            </form>
        );
    }

    return (
        <div className="xappw-admin-input-container visible">
            {joined ? renderLeave() : renderJoin()}
        </div>
    );
};

export default AdminBar;
